import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { GetAllLastPlayedParams } from "./user-games.model";

export const ACTION_PREFIX = "[User Games]";
export const USER_GAMES_ACTION_TYPE = {
	getAllLastPlayed: `${ACTION_PREFIX} Get All Last Played Games`,
	getAllLastPlayedSuccess: `${ACTION_PREFIX} Get All Last Played Games Success`,
	getAllLastPlayedFail: `${ACTION_PREFIX} Get All Last Played Games Fail`,
	updateLastPlayedGame: `${ACTION_PREFIX} Update Last Played Game`,

	reset: `${ACTION_PREFIX} Reset ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class UserGamesAction {
	getAllLastPlayed(params?: GetAllLastPlayedParams): ActionWithPayload {
		return {
			type: USER_GAMES_ACTION_TYPE.getAllLastPlayed,
			payload: params,
		};
	}

	getAllLastPlayedSuccess(lastPlayedGames: string[]): ActionWithPayload {
		return {
			type: USER_GAMES_ACTION_TYPE.getAllLastPlayedSuccess,
			payload: lastPlayedGames,
		};
	}

	getAllLastPlayedFail(error: AppError): ActionWithPayload {
		return {
			type: USER_GAMES_ACTION_TYPE.getAllLastPlayedFail,
			payload: error,
		};
	}

	updateLastPlayedGame(lastPlayedGame: string): ActionWithPayload {
		return {
			type: USER_GAMES_ACTION_TYPE.updateLastPlayedGame,
			payload: lastPlayedGame,
		};
	}

	reset(): Action {
		return {
			type: USER_GAMES_ACTION_TYPE.reset,
		};
	}
}
